/**
 * Detects if the current device is a mobile/touch device
 */
export const isMobile = (): boolean => {
  // Primary check: If we have touch events support
  if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
    // Secondary check: screen size or user agent
    return window.innerWidth <= 768 || /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
  return false;
};

/**
 * Detects if we should use tap interface instead of drag
 * This could be extended with user preferences in the future
 */
export const shouldUseTapInterface = (): boolean => {
  return isMobile();
}; 